import { useEffect } from 'react';
import { useFetchActionEligibility } from '../hooks/useFetchActionEligibility';
import { useFetchPotentiallyStaleProperties } from '../hooks/useFetchPotentiallyStaleProperties';
import { useSubscription } from '../hooks/useSubscription';
import { useSubscriptionActions } from '../hooks/useSubscriptionActions';
import { setObjectId } from '../store/actionsSlice';
import { useAppDispatch, useAppSelector } from '../store/rootReducer';
import { ActionModal } from '../features/subscription-actions/components/ActionModal';
import { SubscriptionActions } from '../types/subscriptions';
import { values } from '../utils/common';
import { useNotificationsQuery } from '../features/subscription-actions/hooks/useNotificationsQuery';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SubscriptionsActionsHost({
  objectId,
  closeSidebar,
  children
}) {
  const dispatch = useAppDispatch();
  const stateObjectId = useAppSelector(s => s.actions.objectId);
  const subscription = useSubscription();
  useFetchActionEligibility();
  const fetchPotentiallyStaleData = useFetchPotentiallyStaleProperties(objectId);
  const actions = useSubscriptionActions();
  useNotificationsQuery();
  useEffect(() => {
    if (stateObjectId !== objectId) {
      dispatch(setObjectId(objectId));
    }
  }, [objectId, stateObjectId, dispatch]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      "data-test-id": `subscription-actions-host:${subscription ? 'done' : 'loading'}`,
      children: values(SubscriptionActions).map(actionName => /*#__PURE__*/_jsx(ActionModal, {
        objectId: objectId,
        actionType: actionName,
        actions: actions,
        refetchStaleData: fetchPotentiallyStaleData,
        closeSidebar: closeSidebar
      }, `${actionName}-${objectId}`))
    }), children]
  });
}
export default SubscriptionsActionsHost;